<template>
	<div>
		<div class="grid-md gutters-100-md">
			<div :class="['col-6-md', { 'col-offset-3-md': applyOffset }]" data-test="asset-type-allocation-table">
				<AllocationBreakdownTable
					table-heading="Asset type allocation"
					:allocations="formattedAssetTypeAllocations"
				/>
			</div>
			<div v-if="hasStrategyAllocations" class="col-6-md mt-100-smo" data-test="strategy-allocation-table">
				<AllocationBreakdownTable
					table-heading="Strategy allocation"
					:allocations="formattedStrategyAllocations"
					:cta-link="strategyAllocationCta"
				/>
			</div>
		</div>
		<div v-if="assetElements.length" class="mt-300 mt-400-md">
			<AssetElementContainer :asset-elements="props.assetElements" :use-icon-view-options="true" />
		</div>
	</div>
</template>
<script setup lang="ts">
import AllocationBreakdownTable from '@components/offering-details/allocation-breakdown-table.vue';
import { Asset } from 'types/assets';
import AssetElementContainer from '@components/asset-element/asset-element-container.vue';
import { computed } from 'vue';
import { FundAssetAllocation } from 'types/funds';
import { Link } from 'types/layout';
import { PercentageAllocation } from 'types/reit-details';

interface Props {
	assetElements: Array<Asset>;
	strategyAllocations: Array<FundAssetAllocation>;
	assetTypeAllocations: Array<FundAssetAllocation>;
	centerAssetAllocations?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	centerAssetAllocations: false
});

const strategyAllocationCta: Link = {
	router: 'blog-post',
	params: {
		blogPostUrlSlug: 'real-estate-strategies'
	}
};

const formattedStrategyAllocations = computed((): Array<PercentageAllocation> => {
	return props.strategyAllocations.map((allocation) => {
		return {
			percentage: allocation.allocationPercent ?? '',
			allocation: allocation.name ?? ''
		};
	});
});

const formattedAssetTypeAllocations = computed((): Array<PercentageAllocation> => {
	return props.assetTypeAllocations.map((allocation) => {
		return {
			percentage: allocation.allocationPercent ?? '',
			allocation: allocation.name ?? ''
		};
	});
});

const hasStrategyAllocations = computed((): boolean => formattedStrategyAllocations.value.length > 0);

const applyOffset = computed((): boolean => !hasStrategyAllocations.value && props.centerAssetAllocations);
</script>
